







































import {Component, Vue} from "vue-property-decorator";
import {CollectCompany} from "@/entity/CollectCompany";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Customer} from "@/entity/Customer";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {CustomerDto} from "@/dto/CustomerDto";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {RealTimeInfoReqDto} from "@/dto/RealTimeInfoReqDto";
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import Header from "@/views/KeShangAdmin/Header.vue";
import {Page} from "@/oauth/Page";
import RealTimeInfoReq from "@/dto/RealTimeInfoReq";
import {CompanyInfo} from "@/entity/CompanyInfo";
import {QingApp} from "@/entity/QingApp";
import {QueryRelationInfoDto} from "@/dto/queryRelationInfoDto";


@Component({
  components: {Header},
})

export default class XXHeader extends Vue {
  public demo: UserInfoEntity[] = [];
  public demo1 = '';
  public companyList: CompanyInfo[] = [];
  public companyInfo = new CompanyInfo();

  public collectCompany = new CollectCompany()
  private customers: Customer[] = [];
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  page: Page<RealTimeInfo>=new Page<RealTimeInfo>();

  get userName() {
    return this.ls.loginUser.username
  }

  get currentName() {
    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }

  private module: CustomerStore = getModule(CustomerStore);

  async handleClick(c: UserInfoEntity) {
    const realTimeInfoReq = new RealTimeInfoReq();
    realTimeInfoReq.infoType='01';
    realTimeInfoReq.page=1;
    realTimeInfoReq.size=5;
    if(c!==null&&c!==undefined) {
      this.demo1 = c.companyNameIdentity as string;
      realTimeInfoReq.userName = this.su.getLoginUser().username;
      realTimeInfoReq.companyId = c.companyId as string;
      realTimeInfoReq.userIdentity = c.userIdentity as string;
      const page: RealTimeInfoReq=await RealTimeInfoReqDto.queryRealList(realTimeInfoReq);
      const newsList=page.content;
      newsList.sort((o1, o2) => {
        return (o2.infoReadTime as number) - (o1.infoReadTime as number)
      })
      console.log(newsList);
      await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
      await getModule(RealTimeInfoStore).setQueryInfo(c)
      localStorage.setItem("demo1", JSON.stringify(c));
    }else {
      realTimeInfoReq.userName=this.su.getLoginUser().username;
      const page: RealTimeInfoReq=await RealTimeInfoReqDto.queryRealList(realTimeInfoReq);
      const newsList = page.content;
      newsList.sort((o1, o2) => {
        return (o2.infoReadTime as number) - (o1.infoReadTime as number)
      })
      await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
      await getModule(RealTimeInfoStore).setQueryInfo(c)
    }
    this.$emit('identity', 'star')
    localStorage.setItem("infoReal", JSON.stringify({"infoType": '01', "size": 5}));
  }

  async handleCompanyClick(companyInfo: CompanyInfo) {
    //初始化轻应用列表
    await this.initAppList();
    //初始化资讯列表
    await this.initRealTimeList(companyInfo);
  }

  private async initAppList() {
    //1.从localstorage中获取选中的组织信息
    const selectedCompanyInfo: CompanyInfo = JSON.parse(localStorage.getItem('selectedCompanyInfo') as string);
    //2.根据选中的公司信息和用户信息获取轻应用列表
    const qingApp = new QingApp();
    if (selectedCompanyInfo !== null) {
      //如果有选中的组织，则将组织ID作为参数传递
      qingApp.companyId = selectedCompanyInfo.companyId;
    }
    qingApp.userName = this.su.getLoginUser().username;
    const appList = await QueryRelationInfoDto.queryRelationInfo(qingApp)
    localStorage.setItem("appList", JSON.stringify(appList));
  }

  private async initRealTimeList(companyInfo: CompanyInfo) {
    const realTimeInfoReq = new RealTimeInfoReq();
    realTimeInfoReq.infoType = '01';
    realTimeInfoReq.page = 1;
    realTimeInfoReq.size = 5;
    realTimeInfoReq.userName = this.su.getLoginUser().username;
    if (companyInfo !== null && companyInfo !== undefined) {
      realTimeInfoReq.companyId = companyInfo.companyId as string;
    }
    const page: RealTimeInfoReq = await RealTimeInfoReqDto.queryRealList(realTimeInfoReq);
    const newsList = page.content;
    await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
    await getModule(RealTimeInfoStore).setCompanyInfo(companyInfo)

    this.$emit('identity', 'star')
    localStorage.setItem("infoReal", JSON.stringify({"infoType": '01', "size": 5}));
  }

  async goToQingAppList(item: string | number | null = localStorage.getItem('currentCustomerId')) {
    const id = Number(item);

    if (this.customers.some(value => Number(value.id) === id)) {
      if (this.$route.params.id !== item) {
        await this.$router.replace({name: 'QingAppList', params: {id: id + ''}});
      }
    } else if (this.customers.length > 0) {
      await this.$router.replace({name: 'QingAppList', params: {id: this.customers[0].id + ''}});
    } else {
      // this.$q.notify({message: '您没有所属的客商,无法使用轻应用', type: 'negative'});
      console.log('-')
    }
  }

  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  async findAllCompanyName() {
    const id = this.su.getLoginUser().id as number;
    this.collectCompany = await CollectCompanyDto.findById(id)
    const aa = this.collectCompany.customerAppId as number;
    this.goQingAppList(aa);
    // console.log(this.customers[0])

  }

  async goQingAppList(ids: number) {
    const id = this.su.getLoginUser().id as number;
    this.collectCompany = await CollectCompanyDto.findById(id)

    if (this.collectCompany.isReviewPass) {
      await this.$router.replace({name: 'QingAppList', params: {id: ids + ''}});
    } else {
      // this.$q.notify({message: '您没有所属的客商,无法使用轻应用', type: 'negative'});
      // console.log('-')
    }
  }

  async authentication() {
    const userInfoEntity = new UserInfoEntity()
    userInfoEntity.userName = this.su.getLoginUser().username
    const identity = await UserInfoEntityDto.selectCompanyInfo(userInfoEntity)
    if (identity !== null && identity.length > 0) {
      identity.forEach(value => {
        this.demo.push(value)
      })
    } else {
      const useinfo: UserInfoEntity = new UserInfoEntity();
      useinfo.userName = this.su.getLoginUser().username;
      localStorage.setItem("demo1", JSON.stringify(useinfo));
    }

  }

  async initCompanyInfo() {
    //1.从localstorage中获取选中公司信息
    const selectedCompanyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as string);
    const companyList = JSON.parse(localStorage.getItem("companyList") as string);
    if (selectedCompanyInfo === null || companyList === null) {
      //2.如果获取不到，尝试从接口中再获取一次,并将第一条存到localstorage中
      //如果能获取到，则不做任何操作
      const userInfo = new UserInfoEntity();
      userInfo.userName = this.su.getLoginUser().username;
      const companyList = await UserInfoEntityDto.selectCompanyInfo(userInfo);
      this.companyList = companyList;
      if (companyList !== null && companyList.length > 0) {
        this.companyInfo = companyList[0];
        localStorage.setItem("selectedCompanyInfo", JSON.stringify(companyList[0]));
        localStorage.setItem("companyList", JSON.stringify(companyList));
        await this.handleCompanyClick(companyList[0]);
      }
    }else {
      this.companyInfo = selectedCompanyInfo;
      this.companyList = companyList;
      await this.handleCompanyClick(this.companyInfo);
    }
  }

  private async mounted() {
    await this.initCompanyInfo();
    /*
    await this.findAll();
    // await this.findAllCompanyName();
     await this.authentication();
     const demo1: UserInfoEntity = JSON.parse(localStorage.getItem("demo1") as string);
     if (demo1 != null) {
       const demo = this.demo.find(value => value.companyNameIdentity === demo1.companyNameIdentity) as UserInfoEntity;
       await this.handleClick(demo);
     } else {
       if (this.demo.length > 0) {
         await this.handleClick(this.demo[0]);
       }
     }

     */
  }


}
